import { render, staticRenderFns } from "./Endereco.vue?vue&type=template&id=6eba3d74&"
import script from "./Endereco.vue?vue&type=script&lang=js&"
export * from "./Endereco.vue?vue&type=script&lang=js&"
import style0 from "./Endereco.vue?vue&type=style&index=0&id=6eba3d74&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports